var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L10.7931 10.2676C10.3883 10.6724 10.117 10.9444 9.92491 11.1708C9.73847 11.3904 9.67102 11.5171 9.63961 11.6137C9.55804 11.8648 9.55804 12.1352 9.63961 12.3863C9.67102 12.4829 9.73847 12.6096 9.92491 12.8292C10.117 13.0556 10.3883 13.3276 10.7931 13.7324L14.5303 17.4697C14.8232 17.7626 14.8232 18.2374 14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L9.73241 14.7931L9.71089 14.7715C9.33318 14.3939 9.01791 14.0786 8.7814 13.8C8.53473 13.5094 8.32999 13.2098 8.21302 12.8498C8.03357 12.2975 8.03357 11.7025 8.21302 11.1502C8.32999 10.7902 8.53473 10.4906 8.78141 10.2C9.01791 9.9214 9.33318 9.60615 9.71089 9.22845L9.73242 9.20693L13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBasic);
export default __webpack_public_path__ + "static/media/arrow-left-basic.7ab6a1ae.svg";
export { ForwardRef as ReactComponent };